"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoubleDown = void 0;
const PreludeCard_1 = require("../prelude/PreludeCard");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const SelectCard_1 = require("../../inputs/SelectCard");
const Size_1 = require("../render/Size");
const CardType_1 = require("../CardType");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
class DoubleDown extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.DOUBLE_DOWN,
            metadata: {
                cardNumber: 'X40',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.text('Copy your other prelude\'s direct effect.', Size_1.Size.SMALL, true);
                }),
            },
        });
        this.target = undefined;
    }
    canPlay(player) {
        let playedPreludes = player.playedCards.filter((c) => c.cardType === CardType_1.CardType.PRELUDE);
        playedPreludes = playedPreludes.filter((p) => p.name !== this.name);
        const eligiblePreludes = playedPreludes.filter((c) => c.canPlay === undefined || c.canPlay(player));
        return eligiblePreludes.length > 0;
    }
    play(player) {
        const game = player.game;
        const playedPreludes = player.playedCards.filter((c) => c.cardType === CardType_1.CardType.PRELUDE);
        const eligiblePreludes = playedPreludes.filter((c) => c.name !== this.name).filter((c) => c.canPlay === undefined || c.canPlay(player));
        if (eligiblePreludes.length === 0)
            return undefined;
        if (eligiblePreludes.length === 1) {
            game.defer(new DeferredAction_1.DeferredAction(player, () => eligiblePreludes[0].play(player)));
            this.target = eligiblePreludes[0].name;
            game.log('${0} copied ${1} effect', (b) => b.player(player).card(eligiblePreludes[0]));
            return undefined;
        }
        else {
            return new SelectCard_1.SelectCard('Choose prelude card to copy', 'Select', eligiblePreludes, (foundCards) => {
                game.defer(new DeferredAction_1.DeferredAction(player, () => foundCards[0].play(player)));
                this.target = foundCards[0].name;
                game.log('${0} copied ${1} effect', (b) => b.player(player).card(foundCards[0]));
                return undefined;
            });
        }
    }
}
exports.DoubleDown = DoubleDown;
//# sourceMappingURL=DoubleDown.js.map